import { render } from "./ChatbotStep1.vue?vue&type=template&id=151c291c"
import script from "./ChatbotStep1.vue?vue&type=script&lang=js"
export * from "./ChatbotStep1.vue?vue&type=script&lang=js"

import "./ChatbotStep1.vue?vue&type=style&index=0&id=151c291c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__